import axios from "axios";

export const DEFAULT_PROVIDER_GAMES_LIMIT = 20;

export function createProviderGamesPagination(
  limit = DEFAULT_PROVIDER_GAMES_LIMIT,
) {
  return {
    page: 1,
    limit,
    total: 0,
    totalPages: 1,
    hasNextPage: false,
    hasPreviousPage: false,
  };
}

function normalizeGame(game, providerId) {
  const code = game?.code || game?.gameCode || game?.gamecode || game?.id || "";
  const imageUrl = game?.imageUrl || game?.image || game?.img || "";

  return {
    ...game,
    id: game?.id || code,
    productId: game?.productId || providerId || "",
    providerId: game?.providerId || providerId || "",
    code,
    gameCode: game?.gameCode || game?.gamecode || code,
    gameName: game?.gameName || game?.name || code,
    name: game?.name || game?.gameName || code,
    image: imageUrl,
    imageUrl,
    img: game?.img || imageUrl,
  };
}

function extractPagination(payload, fallbackPage, fallbackLimit, itemCount) {
  const paginationSource =
    (payload?.pagination && typeof payload.pagination === "object"
      ? payload.pagination
      : null) ||
    (payload?.meta && typeof payload.meta === "object" ? payload.meta : null) ||
    (payload?.data?.pagination && typeof payload.data.pagination === "object"
      ? payload.data.pagination
      : null) ||
    (payload?.data?.meta && typeof payload.data.meta === "object"
      ? payload.data.meta
      : null) ||
    {};

  const page =
    Number(
      paginationSource?.page ||
        paginationSource?.currentPage ||
        paginationSource?.pageNumber,
    ) || fallbackPage;
  const limit =
    Number(
      paginationSource?.limit ||
        paginationSource?.perPage ||
        paginationSource?.pageSize,
    ) || fallbackLimit;
  const total = Number(
    paginationSource?.total ||
      paginationSource?.totalItems ||
      paginationSource?.count ||
      payload?.total ||
      payload?.totalItems,
  );
  const totalPages =
    Number(
      paginationSource?.totalPages ||
        paginationSource?.lastPage ||
        (total > 0 && limit > 0 ? Math.ceil(total / limit) : 0),
    ) || 0;
  const hasNextPage =
    typeof paginationSource?.hasNextPage === "boolean"
      ? paginationSource.hasNextPage
      : totalPages > 0
        ? page < totalPages
        : itemCount >= limit;

  return {
    page,
    limit,
    total: Number.isFinite(total) ? total : 0,
    totalPages: totalPages || (hasNextPage ? page + 1 : page),
    hasNextPage,
    hasPreviousPage: page > 1,
  };
}

export async function fetchProviderGames({
  apiBaseUrl,
  provider,
  categoryCode,
  page = 1,
  limit = DEFAULT_PROVIDER_GAMES_LIMIT,
}) {
  const providerId = String(
    provider?.productId ||
      provider?.game ||
      provider?.id ||
      provider?.name ||
      "",
  ).trim();
  const normalizedCategoryCode = String(
    categoryCode || provider?.categoryCode || provider?.category || "",
  )
    .trim()
    .toUpperCase();

  if (!providerId) {
    throw new Error("Missing provider id");
  }

  const normalizedCategories =
    normalizedCategoryCode === "SLOT" ? "SLOTS" : normalizedCategoryCode;

  const response = await axios.get(`${apiBaseUrl}/gamelogin/getgamelist`, {
    params: {
      providerId,
      productId: providerId,
      categories: normalizedCategories || undefined,
      categoryCode: normalizedCategories || undefined,
      page,
      limit,
    },
    maxBodyLength: Infinity,
  });

  const games = Array.isArray(response?.data?.games)
    ? response.data.games
    : Array.isArray(response?.data?.data?.games)
      ? response.data.data.games
      : Array.isArray(response?.data?.data)
        ? response.data.data
        : [];

  const normalizedGames = games.map((game) => normalizeGame(game, providerId));

  return {
    games: normalizedGames,
    pagination: extractPagination(
      response?.data,
      page,
      limit,
      normalizedGames.length,
    ),
  };
}
